import React from "react";
import {Box, Button} from "theme-ui";
import {Inline} from "@bedrock-layout/inline";
import {useFormContext} from "react-hook-form";
import {useHistory} from "react-router";

// NOTE: they most likely want to toggle edit/view modes
function FormControls() {
    const {onCancel, onClear, onDelete} = useFormContext()
    const history = useHistory()
    const handleDone = () => {
        history.push('/management')
    }
    return (
        <Box variant="layout.header.form-controls">
            <Inline gutter='md' align="start" stretch="start">
                <Box py={3} px={5} width="145px"/>
                <Button variant="primary" onClick={handleDone}>Done</Button>
            </Inline>
        </Box>
    );
}

export default FormControls;